import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "@idw-types/state/application-state";
import { refreshAxnConfigReduxRequest } from "@redux-requests/axn-config";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import { ContentPageHeader } from "../../common/content-page-header/content-page-header";
import { LoadingIndicator } from "../../common/loading-indicator/loading-indicator";
import { RefreshResultsContainer } from "../refresh-results-container/refresh-results-container";
import { CardContainer } from "../../common/card-container/card-container";
import { resources } from "@constants/hardcoded-strings";
import { ContentPageBody } from "../../common/content-page-body/content-page-body";
import { ButtonTypes } from "@enums/button-types";

export const AxnConfigContainer = () => {
    const dispatch = useDispatch();
    const { isRefreshing, lastRefreshDate, refreshResults } = useSelector((state: ApplicationState) => ({
        isRefreshing: state.axnConfig.isRefreshing,
        lastRefreshDate: state.axnConfig.lastRefreshDate,
        refreshResults: state.axnConfig.refreshResults
    }));

    const onClickRefreshConfig = () => {
        refreshAxnConfigReduxRequest(dispatch)();
    };

    const headerButton = useMemo(() => {
        return (
            <ButtonWithSpinner
                id="axn-config-refresh-config-button"
                onClick={onClickRefreshConfig}
                disabled={isRefreshing}
                variant="primary"
                label={resources.common.buttons.refresh.label}
                type={ButtonTypes.BUTTON}
            />
        );
    }, [isRefreshing]);

    return (
        <CardContainer>
            <ContentPageHeader title={resources.pages.axnConfig.header} headerButton={headerButton} />
            <ContentPageBody isMaxWidth={true}>
                {!isRefreshing && refreshResults && (
                    <RefreshResultsContainer refreshResults={refreshResults} lastRefreshDate={lastRefreshDate} />
                )}
                {isRefreshing && (
                    <LoadingIndicator title={resources.pages.axnConfig.loadingIndicatorText} />
                )}
            </ContentPageBody>
        </CardContainer>
    );
};